import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Input, Select } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { TRADING_PARTNERS } from "./const";
import { FSI_CREATE_ORDERS } from "./graphql";

const NewOrdersForm = ({ initialOrders, hide }) => {
  const [orders, setOrders] = useState(initialOrders);

  console.log("orders", orders);

  const [createOrder, createOrderRes] = useMutation(FSI_CREATE_ORDERS, {
    onCompleted(res) {
      const failOrders = res.fsiCreateOrders.orders.filter(
        (order) => order.status === "fail",
      );
      if (failOrders.length > 0) {
        Alert(
          "error",
          `Fail to create ${failOrders.length} order${failOrders.length > 1 ? "s" : ""}.`,
        );
      } else {
        Alert("success", "Orders created Success.");
      }
      hide();
    },
    onError(error) {
      Alert("error", error.message);
    },
    refetchQueries: ["FETCH_FSI_ORDERS"],
    awaitRefetchQueries: true,
  });

  return (
    <div>
      <div className="space-y-8 text-sm">
        {orders.map((order, index) => (
          <div key={index} className="space-y-4 card">
            <div className="flex items-baseline space-x-6">
              <h5>{order.orderNumber}</h5>
              <div>{order.orderDate}</div>
            </div>
            <div>
              <label htmlFor="">alternateOrderNumber / PO: </label>
              {order.alternateOrderNumber}
            </div>
            <div>
              <label htmlFor="">Order Message: </label>
              {order.orderMessage}
            </div>
            <div className="flex space-x-8 items-center">
              <div className="flex space-x-2">
                <label>Shipping Code:</label>
                <div>{order.shippingCode}</div>
              </div>

              <div className="flex space-x-2 items-center">
                <label htmlFor="">Trading Partner:</label>
                <Select
                  value={order.tradingPartner}
                  onChange={(e) =>
                    setOrders((prev) =>
                      prev.map((prevOrder, prevIndex) => {
                        if (index === prevIndex)
                          return {
                            ...prevOrder,
                            tradingPartner: e.target.value,
                          };
                        return prevOrder;
                      }),
                    )
                  }
                >
                  {TRADING_PARTNERS.map((i) => (
                    <option key={i.code} value={i.code}>
                      [{i.code}] {i.name}
                    </option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="flex space-x-8">
              <div>
                <label htmlFor="">Shipping Address:</label>
                <div className="mt-1">{order.shippingAddress.name}</div>
                <div>{order.shippingAddress.address1}</div>
                <div>{order.shippingAddress.address2}</div>
                <div>{order.shippingAddress.city}</div>
                <div>{order.shippingAddress.state}</div>
                <div>{order.shippingAddress.postalCode}</div>
                <Input
                  className="mt-1"
                  value={order.shippingAddress.countryCode}
                  onChange={(e) =>
                    setOrders((prev) =>
                      prev.map((prevOrder, prevIndex) => {
                        if (index === prevIndex)
                          return {
                            ...prevOrder,
                            shippingAddress: {
                              ...prevOrder.shippingAddress,
                              countryCode: e.target.value,
                            },
                          };
                        return prevOrder;
                      }),
                    )
                  }
                />
              </div>
              <div>
                <label htmlFor="">Billing Address:</label>
                <div className="mt-1">{order.billingAddress.name}</div>
                <div>{order.billingAddress.address1}</div>
                <div>{order.billingAddress.address2}</div>
                <div>{order.billingAddress.city}</div>
                <div>{order.billingAddress.state}</div>
                <div>{order.billingAddress.postalCode}</div>
                <Input
                  className="mt-1"
                  placeholder="Country Code"
                  value={order.billingAddress.countryCode}
                  onChange={(e) =>
                    setOrders((prev) =>
                      prev.map((prevOrder, prevIndex) => {
                        if (index === prevIndex)
                          return {
                            ...prevOrder,
                            billingAddress: {
                              ...prevOrder.billingAddress,
                              countryCode: e.target.value,
                            },
                          };
                        return prevOrder;
                      }),
                    )
                  }
                />
              </div>
            </div>

            <div>
              <label htmlFor="">Items: </label>
              <div className="mt-1">
                {order.lineItems.map((i, index) => (
                  <div
                    key={index}
                    className="py-2 border-t dark:border-gray-700 flex justify-between"
                  >
                    <div>[{i.itemNumber}]</div>
                    <div>&times; {i.quantity}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8">
        <Button
          loading={createOrderRes.loading}
          onClick={() =>
            createOrder({ variables: { orders: JSON.stringify(orders) } })
          }
          primary
        >
          Create Orders to FSI
        </Button>
      </div>
    </div>
  );
};

export default NewOrdersForm;
